import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // http请求host
    getSearchData:{},
    httpHost: {
      base: BASE_URL.base,
      login: BASE_URL.login, // 登录
      dic: BASE_URL.dic, // 登录
      buss: BASE_URL.buss, // 业务
      // oa: BASE_URL.oa, // oa
      system: BASE_URL.system, // 后台管理
      file: BASE_URL.file, // 文件
      kkFileView: BASE_URL.kkFileView, // 文件
      adminRest: BASE_URL.adminRest
    },
    loading:false,
    // 变量中的引用地址前缀
    /*pathPre: PATH_PRE,
    // 登录用户个人详细信息
    personDetail: {},
    // 状态背景色
    statusColor: {
      '-1': '#009cdf',
      0: '#979797',
      1: '#009cdf',
      2: '#fd892c',
      3: '#48d2a0',
      4: '#48d2a0',
      6: '#48d2a0',
      8: '#f56767',
      9: '#f56767',
    },
    // 操作按钮背景色
    actionColor: {
      update: '#979797',
      report: '#009cdf',
      delete: '#fd892c',
      revokeReport: '#48d2a0',
      agree: '#48d2a0',
      reject: '#f56767',
      cancel: '#f56767',
    }*/
  },
  getters: {
    // 获取登录信息
    getLoginMessage: (state) => () => {
      let data = localStorage.getItem('loginMessage')
      return data === null ? {} : JSON.parse(data)
    },
    // 获取登录用户详细信息
    getPersonDetail: (state) => () => {
      return state.personDetail
    },
    // 获取变量中的引用地址前缀
    getPathPre: (state) => (step) => {
      return state.pathPre[step]
    },
  },

  // actions:{
  //   update_search({ commit }, data){
  //     commit('',data)
  //   }
  // },
  mutations: {
    // 更新登录信息
    updateLoginMessage (state, data) {
      localStorage.setItem('loginMessage', JSON.stringify(data))
    },
    // 更新登录信息
    updatePersonDetail (state, data) {
      state.personDetail = data
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js